import { EventEmitter, Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SubjectService {
  getselectedmenu = new EventEmitter();
  updateGraphs = new EventEmitter();
  private selectedAssetData$: BehaviorSubject<any> = new BehaviorSubject(null);
  private assetData$: BehaviorSubject<any> = new BehaviorSubject(null);
  public filterData$: BehaviorSubject<any> = new BehaviorSubject(null);
  private currentUserInfi$: BehaviorSubject<any> = new BehaviorSubject(null);
  private lastUpdatedDate$: BehaviorSubject<any> = new BehaviorSubject(null);
  private socket;
  updateShift = new BehaviorSubject(null);
  private historyUpdated = new Subject();
  updatedgraphdata = new EventEmitter();
  getToggleValue = new EventEmitter();
  monitordata = new EventEmitter();

  constructor() {}
  setselectedmenu(data) {
    this.getselectedmenu.emit(data);
  }
  setToggleValue(data, screen) {
    if (screen) {
      this.getToggleValue.emit(data)
    }
  }
  sendFilterData(data) {
    this.filterData$.next(data);
  }
  getUpdateGraphsData(data) {
    this.updateGraphs.emit(data);
  }
  getCurrentUserInfo(): Observable<any> {
    return this.currentUserInfi$.asObservable();
  }
  updateShiftDetails(data, screen?) {
    this.updateShift.next(data);
  }
  /* Set Selected Asset Data */
  setCurrentUserInfo(value: any) {
    this.currentUserInfi$.next(value);
  }

  /* Get Selected Asset Data */
  getSelectedAssetData(): Observable<any> {
    return this.selectedAssetData$.asObservable();
  }

  /* Set Selected Asset Data */
  setSelectedAssetData(value: any) {
    this.selectedAssetData$.next(value);
  }

  /* Get Selected Asset Data */
  getAssetData(): Observable<any> {
    return this.assetData$.asObservable();
  }

  /* Set Selected Asset Data */
  setAssetData(value: any) {
    this.assetData$.next(value);
  }

  sendupdatedgraphdata(data) {
    this.updatedgraphdata.emit(data);
  }

  /* Get last updated date */
  getLastUpdatedDate(): Observable<any> {
    return this.lastUpdatedDate$.asObservable();
  }

  /* Set last updated */
  setLastUpdatedDate(value: any) {
    this.lastUpdatedDate$.next(value);
  }
  setupSocketConnection() {
    //if (!this.socket && environment.mode == "edge") {
    //this.socket = io(environment.socket_endpoint);
    this.socket.on("history_room", (data) => {
      if (data) {
        this.historyUpdated.next(data);
      }
    });
    //}
  }
  getHistoryUpdateListener() {
    return this.historyUpdated.asObservable();
  }

  monitorGraphDataUpdate(data) {
    this.monitordata.emit(data);
  }
}
